import { Container } from 'react-bootstrap';
import { Link as ScrollTo } from 'react-scroll';
import { FaRegHandshake, FaRegThumbsUp } from 'react-icons/fa';
import { FaUnlockKeyhole } from 'react-icons/fa6';
import { MdOutlineAttachMoney } from 'react-icons/md';

const reasons = [
	{
		icon: FaRegHandshake,
		title: 'Trusted Global Network',
		description:
			'Partner with a logistics team that has nurtured long-term relationships with carriers, customs agents, and port authorities worldwide.',
		accent: 'from-[#FF7A59] to-[#FFB347]',
	},
	{
		icon: FaUnlockKeyhole,
		title: 'Advanced Cargo Security',
		description:
			'Every shipment is protected by end-to-end monitoring, tamper-proof seals, and proactive risk intelligence for complete peace of mind.',
		accent: 'from-[#2563EB] to-[#38BDF8]',
	},
	{
		icon: FaRegThumbsUp,
		title: 'Guaranteed Service Levels',
		description:
			'We stand by on-time delivery targets with transparent milestones, giving your team clear visibility and confidence in every move.',
		accent: 'from-[#8B5CF6] to-[#EC4899]',
	},
	{
		icon: MdOutlineAttachMoney,
		title: 'Optimised Cost Structures',
		description:
			'Unlock custom pricing models and consolidated routes that keep your logistics budget lean without compromising on quality.',
		accent: 'from-[#10B981] to-[#34D399]',
	},
];

const ReasonSection = () => {
	return (
		<Container className='py-12 sm:py-16 md:py-24'>
			<section className='relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#EAF4FF] via-white to-[#F5F9FF] px-5 py-8 shadow-xl sm:px-8 md:p-14'>
				<div className='mx-auto flex max-w-4xl flex-col items-center text-center'>
					<span className='inline-flex items-center rounded-full bg-white/60 px-4 py-1 text-xs font-semibold tracking-[0.3em] text-tprimary uppercase'>
						Why choose us
					</span>
					<h2 className='mt-6 text-[32  px] font-semibold text-slate-900 md:text-4xl'>
						Delivering reliability, security &amp; value for every shipment
					</h2>
					<p className='mt-4 text-base text-slate-600 md:text-lg'>
						We combine intelligent routing, proactive communication, and a
						global support network to keep your supply chain moving without
						friction.
					</p>
				</div>

				<div className='mt-10 grid grid-cols-2 gap-5 sm:mt-12 sm:grid-cols-1 sm:gap-7 xl:grid-cols-4'>
					{reasons.map(({ icon: Icon, title, description, accent }) => (
						<div
							key={title}
							className='group relative flex flex-col rounded-2xl border border-white/70 bg-white/90 px-5 pb-8 pt-12 text-center shadow-sm backdrop-blur transition-all duration-300 hover:-translate-y-1 hover:border-transparent hover:shadow-xl sm:px-6 sm:pt-14'
						>
							<span
								className={`relative left-1/2 inline-flex h-14 w-14 -translate-x-1/2 items-center justify-center rounded-full bg-gradient-to-br ${accent} text-white shadow-lg transition-transform duration-300 group-hover:scale-110 sm:absolute sm:-top-8 sm:h-16 sm:w-16`}
							>
								<Icon className='text-xl sm:text-2xl md:text-3xl' />
							</span>
							<h3 className='mt-6 text-base font-semibold text-slate-900 sm:mt-4 sm:text-lg md:text-xl'>
								{title}
							</h3>
							<p className='mt-3 leading-relaxed text-slate-600 sm:text-[15px] md:text-base'>
								{description}
							</p>
						</div>
					))}
				</div>

				<div className='mt-10 flex flex-col items-center justify-between gap-6 text-center sm:mt-12 md:text-left'>
					<p className='max-w-2xl text-sm text-slate-600 sm:text-[15px] md:text-base'>
						Ready to experience a logistics partner that treats your goals like
						our own? We tailor every journey to fit your timelines, compliance
						needs, and growth ambitions.
					</p>
					<ScrollTo
						to='contact'
						smooth
						duration={600}
						offset={-80}
						className='inline-flex cursor-pointer items-center gap-2 rounded-full bg-tprimary px-5 py-3 text-sm font-semibold text-white shadow-lg transition hover:bg-[#ff4d4d]'
					>
						Talk to an expert
					</ScrollTo>
				</div>
			</section>
		</Container>
	);
};

export default ReasonSection;
